export default __webpack_public_path__ + "static/media/gl.72ed9774.jpg";